
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { MentoringNumberIcon } from './components';
import { IMentoringNumber } from './types';

@Component({
  components: {
    MentoringNumberIcon,
  },
})
export default class MentoringNumber extends Vue implements IMentoringNumber {
  @Prop({ type: [Number, String], default: 1 })
  readonly number!: string | number;

  @Prop({ type: String, default: '' })
  readonly text!: string;

  @Prop({ type: Boolean, default: false })
  readonly isEnd!: boolean;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/process/components/number/MentoringNumber.vue